export default {
  install: (app) => {
    app.config.globalProperties.$filters = {
      currencyFormat(value) {
        return '$ ' + Number(value).toLocaleString('es')
      }
    }
  }
}
